import React, { useState, useEffect } from 'react'
import Spiner from '../../components/modals/Spiner'
import userLogic from '../../functions/logic/userLogic'
import '../../scss/HistorialPedidos.scss'

export default function HistorialPedidos() {
  const [spiner, setSpiner] = useState(false)
  const [orders, setOrders] = useState([])
  const [totalPaginas, setTotalPaginas] = useState([])

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    const isLoggedIn = !!token

    if (!isLoggedIn) {
      window.location.href = global.HOME
    }

    getHistoryOrders()
  }, [])

  const getHistoryOrders = async () => {
    setSpiner(true)

    const orderResp = await userLogic.getHistoryOrdersLogic()

    if (orderResp.success && orderResp.data.data.length > 0) {
      setOrders(orderResp.data.data)
    }

    setSpiner(false)
  }

  const pedidosPorPagina = 5
  const [paginaActual, setPaginaActual] = useState(1)

  const indiceUltimoPedido = paginaActual * pedidosPorPagina
  const indicePrimerPedido = indiceUltimoPedido - pedidosPorPagina
  const pedidosPaginados = orders.slice(indicePrimerPedido, indiceUltimoPedido)

  useEffect(() => {
    setTotalPaginas(Math.ceil(orders.length / pedidosPorPagina))
  }, [orders.length])

  const cambiarPagina = (pagina) => {
    setPaginaActual(pagina)
  }

  const [acordeonActivo, setAcordeonActivo] = useState(orders[0]?.id || null)

  const toggleAcordeon = (id) => {
    setAcordeonActivo(acordeonActivo === id ? null : id)
  }

  return (
    <div className="historial-page">
      <Spiner opt={spiner} />

      <div className="container historial-container">
        <div className="page-content mt-2 historial-wrapper">
          <h4 className="historial-title">Historial de Pedidos</h4>

          {pedidosPaginados.length === 0 ? (
            <p className="historial-empty">
              No tienes pedidos en tu historial.
            </p>
          ) : (
            pedidosPaginados.map((pedido) => (
              <div
                className="historial-order-card"
                key={pedido.id}
                onClick={() => toggleAcordeon(pedido.id)}
              >
                <div
                  className="historial-order-header"
                  onClick={() => toggleAcordeon(pedido.id)}
                >
                  <p className="historial-order-number mb-0">
                    Pedido #{pedido.numero_orden}
                  </p>

                  <span
                    className={`historial-order-arrow ${
                      acordeonActivo === pedido.id ? 'active' : ''
                    }`}
                  >
                    <i className="icon-angle-down"></i>
                  </span>
                </div>

                {acordeonActivo === pedido.id && (
                  <div className="historial-order-body">
                    <div className="row">
                      <div className="col-md-6">
                        <h6>
                          <strong>Productos:</strong>
                        </h6>

                        <ul className="list-unstyled">
                          {pedido.details.map((producto) => (
                            <li key={producto.id}>
                              <img
                                src={`${global.IMGProd}${producto.imageUrl}`}
                                alt={producto.name}
                                className="historial-product-image"
                              />

                              <span>
                                {producto.name} - {producto.quantity} x $
                                {producto.price} = ${producto.total}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="col-md-6">
                        <h6>
                          <strong>Dirección de Envío:</strong>
                        </h6>

                        {pedido.address ? (
                          <>
                            <p>
                              <strong>Nombre:</strong> {pedido.address.nombres}{' '}
                              {pedido.address.apellidos}
                            </p>

                            <p>
                              <strong>Dirección:</strong>{' '}
                              {pedido.address.direccion} /{' '}
                              <strong>Calle:</strong> {pedido.address.calle}
                            </p>

                            <p>
                              <strong>Referencia:</strong>{' '}
                              {pedido.address.referencia}
                            </p>

                            <p>
                              <strong>Provincia:</strong>{' '}
                              {pedido.address.provincia_name} /{' '}
                              <strong>Ciudad:</strong>{' '}
                              {pedido.address.canton_name}
                            </p>

                            <p>
                              <strong>Código Postal:</strong>{' '}
                              {pedido.address.codigo_postal}
                            </p>

                            <p>
                              <strong>Teléfono:</strong>{' '}
                              {pedido.address.telefono_contacto}
                            </p>
                          </>
                        ) : (
                          <p>No hay dirección de envío disponible.</p>
                        )}
                      </div>
                    </div>

                    <div className="historial-order-footer">
                      <span className="historial-order-total">
                        <strong>Total:</strong> <span>${pedido.total}</span>
                      </span>

                      <div className="historial-actions">
                        <a
                          href={
                            global.ORDERDETAIL + '?orden=' + pedido.numero_orden
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="historial-action primary"
                          onClick={(event) => event.stopPropagation()}
                        >
                          <span>Detalle de la orden</span>

                          <i className="icon-long-arrow-right"></i>
                        </a>

                        <a
                          href={
                            global.ORDERCRASTREO +
                            '?orden=' +
                            pedido.numero_orden
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="historial-action"
                          onClick={(event) => event.stopPropagation()}
                        >
                          <span>Rastreo</span>

                          <i className="icon-long-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}

          <nav aria-label="Page navigation" className="historial-pagination">
            <ul className="pagination justify-content-center align-items-center mb-0">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => cambiarPagina(paginaActual - 1)}
                  disabled={paginaActual === 1}
                >
                  <i className="icon-long-arrow-left"></i>
                  <span>Anterior</span>
                </button>
              </li>

              <li className="page-item">
                <span className="page-link historial-page-number">
                  Página {paginaActual} de {totalPaginas}
                </span>
              </li>

              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => cambiarPagina(paginaActual + 1)}
                  disabled={paginaActual === totalPaginas}
                >
                  <span>Siguiente</span>
                  <i className="icon-long-arrow-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}
